import { render, staticRenderFns } from "./AlarmConfiguration.vue?vue&type=template&id=65442f12"
import script from "./AlarmConfiguration.vue?vue&type=script&lang=js"
export * from "./AlarmConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports